export const downloadFileMixin = {
  methods: {
    downloadFile(blob) {
      const file = new File([blob], 'test', { type: 'application/pdf' });
      const url = URL.createObjectURL(file);
      window.open(url);
    }
  }
};
